'use client';

import BackIconSvg from '@/assets/svgs/icon-back.svg';
import CloseIconSvg from '@/assets/svgs/x-close.svg';

import classNames from 'classnames';
import { HTMLAttributes } from 'react';
import IconButton from '../IconButton/IconButton';

interface CloseButtonProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  buttonClassName?: string;
  onClose?: () => void;
  iconVariant?: 'close' | 'back';
}

const CloseButton = ({
  className,
  buttonClassName,
  onClose,
  iconVariant = 'close',
  ...rest
}: CloseButtonProps) => {
  return (
    <div className={classNames('', className)} onClick={() => onClose?.()} {...rest}>
      <IconButton
        title={iconVariant === 'close' ? 'Close' : 'Back'}
        className={classNames('btn-ghost', buttonClassName)}
        icon={
          iconVariant === 'close' ? (
            <CloseIconSvg className="h-6 w-6" />
          ) : (
            <BackIconSvg className="h-6 w-6" />
          )
        }
        tabIndex={-1}
      />
    </div>
  );
};

export default CloseButton;
